import { render } from "./MenuAccount.vue?vue&type=template&id=28dfbea5&scoped=true"
import script from "./MenuAccount.vue?vue&type=script&lang=js"
export * from "./MenuAccount.vue?vue&type=script&lang=js"

import "./MenuAccount.vue?vue&type=style&index=0&id=28dfbea5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dfbea5"]])

export default __exports__